// extracted by mini-css-extract-plugin
export default {"tertiatyLink":"m4xyn"};